import React from 'react';
import "./index.scss"

const LoaderComponent = () => {
    return (
        <span className="loader"></span>
    );
};

export default LoaderComponent;